// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OpenOrders: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 61"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M40.3 50.1c-.8 0-1.4.6-1.4 1.4v5.1c0 .3-.3.6-.6.6h-34c-.3 0-.6-.3-.6-.6v-44c0-.3.3-.6.6-.6h6.6v.6c0 .8.6 1.4 1.4 1.4h18c.8 0 1.4-.6 1.4-1.4V12h6.6c.3 0 .6.3.6.6v15.3c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4V12.5c0-1.9-1.5-3.4-3.4-3.4h-6.6v-.6c0-.8-.6-1.4-1.4-1.4h-1.8c-.6-3.4-3.6-6-7.2-6s-6.6 2.6-7.2 6h-1.8c-.8 0-1.4.6-1.4 1.4v.6H4.3C2.4 9.1.9 10.6.9 12.5v44c0 1.9 1.5 3.4 3.4 3.4h34c1.9 0 3.4-1.5 3.4-3.4v-5.1c-.1-.7-.7-1.3-1.4-1.3zm-19-46.2c2.1 0 3.8 1.4 4.4 3.2h-8.8c.6-1.9 2.3-3.2 4.4-3.2zm-7.7 6h15.3v1.2H13.6V9.9z"/><path d="M54.1 31.9c0-.6-.2-1.1-.6-1.5l-4-4c-.8-.8-2.3-.8-3.1 0l-2.8 2.8v.1L32.1 40.8c-.2.2-.3.3-.3.5l-2.4 7.4c-.2.5 0 1 .3 1.4.3.3.6.4 1 .4.1 0 .3 0 .4-.1l7.6-2.3.6-.3 11.5-11.6v-.1l2.8-2.8c.3-.2.5-.8.5-1.4zM37.5 45.7l-4.7 1.4 1.5-4.6 10.4-10.4 3.2 3.2-10.4 10.4zm12.2-12.3l-3.2-3.2 1.4-1.4 3.2 3.2-1.4 1.4z"/></svg>;
};

export default React.memo(OpenOrders);
